module.exports = __webpack_public_path__ + "static/media/portugal2020.1a1e76d9.webp";